import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { COMPANY_INFO } from '../data/mockData';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <SEO title="403 - Adgang nægtet | K-TO Ventilationsteknik" />

      <div className="max-w-2xl w-full bg-white rounded-3xl p-8 sm:p-12 border border-slate-200 shadow-xl text-center space-y-6">
        <div className="w-20 h-20 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center font-black text-3xl mx-auto shadow-inner">
          403
        </div>

        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">
          Adgang nægtet
        </h1>

        <p className="text-slate-600 text-sm leading-relaxed max-w-md mx-auto">
          Du har ikke rettigheder til at tilgå denne ressource. Du kan i stedet vælge et af områderne nedenfor.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-3 pt-4 text-xs font-bold uppercase tracking-wider">
          <Link
            to="/"
            className="bg-sky-600 hover:bg-sky-700 text-white px-5 py-3 rounded-xl transition-colors"
          >
            Gå til forsiden
          </Link>

          <Link
            to="/ydelser/service-og-ventilation"
            className="bg-slate-100 hover:bg-slate-200 text-slate-800 px-5 py-3 rounded-xl transition-colors"
          >
            Se ydelser
          </Link>

          <Link
            to="/galleri"
            className="bg-slate-100 hover:bg-slate-200 text-slate-800 px-5 py-3 rounded-xl transition-colors"
          >
            Se galleri
          </Link>

          <Link
            to="/kontakt"
            className="bg-slate-900 hover:bg-slate-800 text-white px-5 py-3 rounded-xl transition-colors"
          >
            Kontakt os
          </Link>
        </div>

        <div className="pt-6 border-t border-slate-100 text-xs text-slate-500">
          Ring direkte til os på{' '}
          <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-extrabold text-sky-600 hover:underline nowrap-contact">
            22 72 87 23
          </a>
        </div>
      </div>
    </div>
  );
}
